
<script>
import {
  newGetAppResourceGroups
} from "@/api/desk/notice";
import loadmore from './loadmore'
export default {
  props: ['value', 'placeholder', 'singleSelect', 'params', 'size'],
  directives: { loadmore },
  data() {
    return {
      // value:'',
      options: [],
      resList: [],
      loading: false,
      sliceIndexS: 0,
      sliceIndexE: 20,
      showOption: true,
    }
  },
  watch: {
    value(val) {
      this.$emit('input', val)
    }
  },
  created() {
    this.getChannelListFn()
  },
  methods: {
    // 搜索
    filterablenFn(val) {
      if (val) {
        this.showOption = false
        this.options = this.resList.filter((item) => {
          if (!!~item.name.indexOf(val) || !!~item.name.toUpperCase().indexOf(val.toUpperCase())) {
            return true
          }
        })
      }
    },
    // 下拉框出现/隐藏时触发
    selectChange(is) {
      this.showOption = is
      if (!is) {
        this.sliceIndexS = 0,
          this.sliceIndexE = 20
        this.options = this.resList.slice(this.sliceIndexS, this.sliceIndexE)
      }
    },
    // 下拉触底事件
    loadMore() {
      if (this.sliceIndexE <= this.resList.length && this.showOption) {
        this.loading = true
        this.sliceIndexS += 20
        this.sliceIndexE += 20
        this.options.push(...this.resList.slice(this.sliceIndexS, this.sliceIndexE))
        this.loading = false
      }
    },
    // 处理label 名称
    setName(list = []) {
      let data = list.map(item => {
        return {
          id: item.code,
          name: item.name
        }
      })
      return data || []
    },
    // 获取筛选资源数据
    async getChannelListFn() {
      let res = await newGetAppResourceGroups({
        current: 1,
        size: 999
      })
      console.log('获取资源组', res);
      if (res.status === 200) {
        this.resList = this.setName(res.data.data.records)
        this.options = this.setName(res.data.data.records.slice(0, 20))
      }
    },
  }
}
</script>
<template>
  <div>
    <el-select @visible-change="selectChange" :filter-method="filterablenFn" v-loadmore="loadMore" filterable clearable
      collapse-tags :multiple="!singleSelect" :size="size" v-model="value" :placeholder="placeholder || '请选择资源组'">
      <el-option v-for="item of options" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
      <el-option label="" value="" disabled v-if="loading">
        <div style="text-align: center;">
          <i class="el-icon-loading"></i>
        </div>
      </el-option>
    </el-select>
  </div>
</template>
